// extracted by mini-css-extract-plugin
export default {"changePageBox":"changePageBox--RH42W","changePageBtn":"changePageBtn--b_KPG","title":"title--P7thj","next":"next--zTEkK","pre":"pre--w4bAP"};